export default {
    name: 'section-grossesse',
    components: {},
    props: ["consultation", "is_printable"],
    data() {
        return {
            grossesse: {
                date_derniere_regle: '',
                age: '',
                date_prob_accouch: '',
                hu: '',
                bdcf: '',
                consultation_id: 0,
                bdcf_selected: {
                    nom: ''
                },
                albumi: {
                    nom: '',
                    id: '',
                },
                albumi_selected: {
                    nom: '',
                    id: '',
                },
                presence_oedeme: {
                    nom: ''
                },
                maf: {
                    nom: ''
                },
            },
        }
    },
    computed: {
        user_role() {
            return this.$store.getters['activeRole'].nom;
        },
        grossesse_en_cours() {
            return this.$store.getters['cpn_grossesse_courante'];
        },
    },

    mounted() {
        this.$store.dispatch("getGrossesseEnCours", { consultation_id: this.consultation.id }).then(() => {
            console.log("Grossesse CPN: ",this.grossesse_en_cours)
        })
        
    },
    methods: {
        formatDateDDMMYYY: function(given_date) {
            let date = new Date(given_date)
            let month = date.getMonth() + 1,
                day = date.getDate();

            if (month < 10) month = '0' + month
            if (day < 10) day = '0' + day
            let date_to_return = `${day}/${month}/${date.getFullYear()}`;
            return date_to_return
        }
    }
}